import { defineMessages } from 'react-intl';

export const pricingPlanMessages = defineMessages({
    name: {
        id: 'name',
        defaultMessage: 'Name',
    },
    pricingPlan: {
        id: 'pricing-plan',
        defaultMessage: 'Pricing plan',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    editPricingPlan: {
        id: 'edit-pricing-plan',
        defaultMessage: 'Edit pricing plan',
    },
    addPricingPlanSubtitle: {
        id: 'add-pricing-plan-subtitle',
        defaultMessage: 'Create a new pricing plan that you will be able to assign',
    },
    editPricingPlanSubtitle: {
        id: 'edit-pricing-plan-subtitle',
        defaultMessage: 'Edit pricing plan {entry}',
    },
    deletePricingPlanSubtitle: {
        id: 'delete-pricing-plan-subtitle',
        defaultMessage: 'Permanently delete pricing plan {entry}',
    },
    confirmDeletePricingPlan: {
        id: 'confirm-delete-pricing-plan',
        defaultMessage: 'Are you sure you want to delete pricing plan {entry}? This action cannot be undone.',
    },
    createPricingPlanSuccessDescription: {
        id: 'create-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully created.',
    },
    updatePricingPlanSuccessDescription: {
        id: 'update-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully updated.',
    },
    deletePricingPlanSuccessDescription: {
        id: 'delete-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully deleted.',
    },
    createPricingPlanSuccess: {
        id: 'create-pricing-plan-success',
        defaultMessage: 'Pricing plan created',
    },
    updatePricingPlanSuccess: {
        id: 'update-pricing-plan-success',
        defaultMessage: 'Pricing plan updated',
    },
    deletePricingPlanSuccess: {
        id: 'delete-pricing-plan-success',
        defaultMessage: 'Pricing plan deleted',
    },
    dashboard: {
        id: 'dashboard',
        defaultMessage: 'Dashboard',
    },
    plan: {
        id: 'plan',
        defaultMessage: 'Plan',
    },
    plans: {
        id: 'plans',
        defaultMessage: 'Plans',
    },
    billingType: {
        id: 'billing-type',
        defaultMessage: 'Billing type',
    },
    versionNumber: {
        id: 'version-number',
        defaultMessage: 'Version number',
    },
    activeFrom: {
        id: 'active-from',
        defaultMessage: 'Active from',
    },
    activeTo: {
        id: 'active-to',
        defaultMessage: 'Active to',
    },
    calculationType: {
        id: 'calculation-type',
        defaultMessage: 'Calculation type',
    },
    postBilling: {
        id: 'post-billing',
        defaultMessage: 'Post-billings',
    },
    preBilling: {
        id: 'pre-billing',
        defaultMessage: 'Pre-billings',
    },
    fixedTick: {
        id: 'fixed-tick',
        defaultMessage: 'Fixed tick',
    },
    compoundPeriods: {
        id: 'compound-periods',
        defaultMessage: 'Compound periods',
    },
    totalPeriods: {
        id: 'total-periods',
        defaultMessage: 'Total periods',
    },
    scheduledChanges: {
        id: 'scheduled-changes',
        defaultMessage: 'Scheduled changes',
    },
    currentVersion: {
        id: 'current-version',
        defaultMessage: 'Current version',
    },
    none: {
        id: 'none',
        defaultMessage: 'None',
    },
    repeating: {
        id: 'repeating',
        defaultMessage: 'Repeating',
    },
    oneTime: {
        id: 'one-time',
        defaultMessage: 'One time',
    },
    capping: {
        id: 'capping',
        defaultMessage: 'Capping',
    },
    currency: {
        id: 'currency',
        defaultMessage: 'Currency',
    },
    pricingPlanDashboard: {
        id: 'pricing-plan-dashboard',
        defaultMessage: 'Pricing plan dashboard',
    },
    createNewVersion: {
        id: 'create-new-version',
        defaultMessage: 'Create new version',
    },
    allVersions: {
        id: 'all-versions',
        defaultMessage: 'All versions',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    freeTimeType: {
        id: 'free-time-type',
        defaultMessage: 'Free time type',
    },
    freeTime: {
        id: 'free-time',
        defaultMessage: 'Free time',
    },
    freeTimeCap: {
        id: 'free-time-cap',
        defaultMessage: 'Free time cap',
    },
    exitTime: {
        id: 'exit-time',
        defaultMessage: 'Exit time',
    },
    exitTimeGrace: {
        id: 'exit-time-grace',
        defaultMessage: 'Exit time grace',
    },
    validFromPricing: {
        id: 'valid-from-pricing',
        defaultMessage: 'Valid from',
    },
    validToPricing: {
        id: 'valid-to-pricing',
        defaultMessage: 'Valid to',
    },
    previousVersion: {
        id: 'previous-version',
        defaultMessage: 'Previous version',
    },
    nextVersion: {
        id: 'next-version',
        defaultMessage: 'Next version',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    draft: {
        id: 'draft',
        defaultMessage: 'Draft',
    },
    published: {
        id: 'published',
        defaultMessage: 'Published',
    },
    adjustments: {
        id: 'adjustments',
        defaultMessage: 'Adjustments',
    },
    adjustment: {
        id: 'adjustment',
        defaultMessage: 'Adjustment',
    },
    everyVisit: {
        id: 'every-visit',
        defaultMessage: 'Every visit',
    },
    pastVersion: {
        id: 'past-version',
        defaultMessage: 'Past version',
    },
    tickType: {
        id: 'tick-type',
        defaultMessage: 'Tick type',
    },
    tickDuration: {
        id: 'tick-duration',
        defaultMessage: 'Tick duration',
    },
    perMinute: {
        id: 'per-minute',
        defaultMessage: 'Per minute',
    },
    hourly: {
        id: 'hourly',
        defaultMessage: 'Hourly',
    },
    daily: {
        id: 'daily',
        defaultMessage: 'Daily',
    },
    weekly: {
        id: 'weekly',
        defaultMessage: 'Weekly',
    },
    monthly: {
        id: 'monthly',
        defaultMessage: 'Monthly',
    },
    rates: {
        id: 'rates',
        defaultMessage: 'Rates',
    },
    rate: {
        id: 'rate',
        defaultMessage: 'Rate',
    },
    maxAmount: {
        id: 'max-amount',
        defaultMessage: 'Max amount',
    },
    maxAmountCurrency: {
        id: 'max-amount-currency',
        defaultMessage: 'Max amount ({currency})',
    },
    maxAmountMoreInfo: {
        id: 'max-amount-more-info',
        defaultMessage:
            'The most this rate charges within its time range. Once it is reached, the stay is free until the end of the range. Empty - no limit.',
    },
    hours: {
        id: 'hours',
        defaultMessage: 'Hours',
    },
    day: {
        id: 'day',
        defaultMessage: 'Day',
    },
    startDay: {
        id: 'start-day',
        defaultMessage: 'Start day',
    },
    simulatePricing: {
        id: 'simulate-pricing',
        defaultMessage: 'Simulate pricing',
    },
    simulatePricingTitle: {
        id: 'simulate-pricing-title',
        defaultMessage: 'Pricing simulation',
    },
    simulatePricingSubtitle: {
        id: 'simulate-pricing-subtitle',
        defaultMessage: 'What a stay of the chosen period would be charged by this pricing plan.',
    },
    simulate: {
        id: 'simulate',
        defaultMessage: 'Simulate',
    },
    periodStart: {
        id: 'period-start',
        defaultMessage: 'Start',
    },
    periodEnd: {
        id: 'period-end',
        defaultMessage: 'End',
    },
    rateBand: {
        id: 'rate-band',
        defaultMessage: 'Rate band',
    },
    simulationTier: {
        id: 'tier',
        defaultMessage: 'Tier',
    },
    simulationChange: {
        id: 'simulation-change',
        defaultMessage: 'Change',
    },
    tierUpTo: {
        id: 'tier-up-to',
        defaultMessage: 'up to {duration}',
    },
    tierOver: {
        id: 'tier-over',
        defaultMessage: 'over {duration}',
    },
    tierWholeStay: {
        id: 'tier-whole-stay',
        defaultMessage: 'the whole stay',
    },
    simulationAmount: {
        id: 'simulation-amount',
        defaultMessage: 'Charge',
    },
    simulationTotal: {
        id: 'simulation-total',
        defaultMessage: 'Total',
    },
    simulationTotalDuration: {
        id: 'simulation-total-duration',
        defaultMessage: 'Total duration',
    },
    durationAnd: {
        id: 'duration-and',
        defaultMessage: 'and',
    },
    simulationTotalWithTax: {
        id: 'simulation-total-with-tax',
        defaultMessage: 'Total with VAT',
    },
    simulationTotalWithoutTax: {
        id: 'simulation-total-without-tax',
        defaultMessage: 'Total without VAT',
    },
    simulationTotalTax: {
        id: 'simulation-total-tax',
        defaultMessage: 'Total VAT',
    },
    simulationBreakdown: {
        id: 'simulation-breakdown',
        defaultMessage: 'Breakdown',
    },
    simulationBreakdownForDay: {
        id: 'simulation-breakdown-for-day',
        defaultMessage: 'Breakdown for {day}',
    },
    simulationDayTotal: {
        id: 'simulation-day-total',
        defaultMessage: 'Total: {total}',
    },
    simulationDay: {
        id: 'simulation-day',
        defaultMessage: 'Day',
    },
    simulationRow: {
        id: 'simulation-row',
        defaultMessage: 'Period',
    },
    simulationRows: {
        id: 'simulation-rows',
        defaultMessage: 'Periods',
    },
    simulationFreeTimeRow: {
        id: 'simulation-free-time-row',
        defaultMessage: 'Free time',
    },
    simulationNoRateRow: {
        id: 'simulation-no-rate-row',
        defaultMessage: 'Outside the rate bands',
    },
    simulationNoPlanRow: {
        id: 'simulation-no-plan-row',
        defaultMessage: 'The tariff does not apply',
    },
    simulationVersion: {
        id: 'simulation-version',
        defaultMessage: 'version {number}',
    },
    simulationContext: {
        id: 'simulation-context',
        defaultMessage: 'Applied for',
    },
    simulationVisitorType: {
        id: 'simulation-visitor-type',
        defaultMessage: 'Visitor type',
    },
    visitorTypes: {
        id: 'pricing-plan-visitor-types',
        defaultMessage: 'Visitor types',
    },
    allVisitorTypes: {
        id: 'pricing-plan-all-visitor-types',
        defaultMessage: 'All types',
    },
    simulationContextPlan: {
        id: 'simulation-context-plan',
        defaultMessage: 'The tariff itself',
    },
    simulationCappedRow: {
        id: 'simulation-capped-row',
        defaultMessage: 'Max amount reached',
    },
    endDay: {
        id: 'end-day',
        defaultMessage: 'End day',
    },
    createTickRateSuccess: {
        id: 'create-tick-rate-success',
        defaultMessage: 'Rate created',
    },
    createTickRateSuccessDescription: {
        id: 'create-tick-rate-success-description',
        defaultMessage: 'A new rate has been successfully created.',
    },
    addRateSubtitle: {
        id: 'add-rate-subtitle',
        defaultMessage: 'Add a new rate to this pricing plan',
    },
    fromHour: {
        id: 'from-hour',
        defaultMessage: 'From',
    },
    toHour: {
        id: 'to-hour',
        defaultMessage: 'To',
    },
    deleteTickRateSuccess: {
        id: 'delete-tick-rate-success',
        defaultMessage: 'Rate deleted',
    },
    deleteTickRateSuccessDescription: {
        id: 'delete-tick-rate-success-description',
        defaultMessage: 'Rate has been successfully deleted.',
    },
    deleteTickRateSubtitle: {
        id: 'delete-tick-rate-subtitle',
        defaultMessage: 'Permanently delete rate',
    },
    confirmDeleteTickRate: {
        id: 'confirm-delete-tick-rate',
        defaultMessage: 'Are you sure you want to delete this rate? This action cannot be undone.',
    },
    updateRateSuccess: {
        id: 'update-rate-success',
        defaultMessage: 'Rate updated',
    },
    updateRateSuccessDescription: {
        id: 'update-rate-success-description',
        defaultMessage: 'The rate has been successfully updated.',
    },
    editRateSubtitle: {
        id: 'edit-rate-subtitle',
        defaultMessage: 'Edit the details',
    },
    taxPercent: {
        id: 'tax-percent',
        defaultMessage: 'VAT %',
    },
    validity: {
        id: 'validity',
        defaultMessage: 'Validity',
    },
    rules: {
        id: 'rules',
        defaultMessage: 'Rules',
    },
    taxAttributes: {
        id: 'tax-attributes',
        defaultMessage: 'Tax attributes',
    },
    eur: {
        id: 'eur',
        defaultMessage: 'Euro',
    },
    minutes: {
        id: 'minutes',
        defaultMessage: 'Minutes',
    },
    capped: {
        id: 'capped',
        defaultMessage: 'Capped',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validTo: {
        id: 'valid-to',
        defaultMessage: 'Valid to',
    },
    hour: {
        id: 'hour',
        defaultMessage: 'Hour',
    },
    minute: {
        id: 'minute',
        defaultMessage: 'Minute',
    },
    week: {
        id: 'week',
        defaultMessage: 'Week',
    },
    month: {
        id: 'month',
        defaultMessage: 'Month',
    },
    tiers: {
        id: 'tiers',
        defaultMessage: 'Tiers',
    },
    caps: {
        id: 'caps',
        defaultMessage: 'Caps',
    },
    pricingPlanVersionControl: {
        id: 'pricing-plan-version-control',
        defaultMessage: 'Pricing plan version control',
    },
    editPricingPlanVersion: {
        id: 'edit-pricing-plan-version',
        defaultMessage: 'Edit pricing plan version',
    },
    pricingPlanVersion: {
        id: 'pricing-plan-version',
        defaultMessage: 'Pricing plan version',
    },
    pricingPlanVersions: {
        id: 'pricing-plan-versions',
        defaultMessage: 'Pricing plan versions',
    },
    addPricingPlanVersionSubtitle: {
        id: 'add-pricing-plan-version-subtitle',
        defaultMessage: 'Create a new pricing plan version',
    },
    createPricingPlanVersionSuccess: {
        id: 'create-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version created',
    },
    createPricingPlanVersionSuccessDescription: {
        id: 'create-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully created.',
    },
    updatePricingPlanVersionSuccess: {
        id: 'update-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version updated',
    },
    updatePricingPlanVersionSuccessDescription: {
        id: 'update-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully updated.',
    },
    editPricingPlanVersionSubtitle: {
        id: 'edit-pricing-plan-version-subtitle',
        defaultMessage: 'Edit pricing plan version {entry}',
    },
    deletePricingPlanVersionSubtitle: {
        id: 'delete-pricing-plan-version-subtitle',
        defaultMessage: 'Permanently delete pricing plan version {entry}',
    },
    confirmDeletePricingPlanVersion: {
        id: 'confirm-delete-pricing-plan-version',
        defaultMessage: 'Are you sure you want to delete pricing plan version {entry}? This action cannot be undone.',
    },
    deletePricingPlanVersionSuccess: {
        id: 'delete-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version deleted',
    },
    deletePricingPlanVersionSuccessDescription: {
        id: 'delete-pricing-plan-success-version-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully deleted.',
    },
    copyPricingPlanVersionSubtitle: {
        id: 'copy-pricing-plan-version-subtitle',
        defaultMessage: 'Copy pricing plan version {entry}',
    },
    copyPricingPlanVersionSuccess: {
        id: 'copy-pricing-plan-version-success',
        defaultMessage: 'Pricing plan version copied',
    },
    copyPricingPlanVersionSuccessDescription: {
        id: 'copy-pricing-plan-version-success-description',
        defaultMessage: 'Pricing plan version {entry} has been successfully copied.',
    },
    cash: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    web: {
        id: 'web',
        defaultMessage: 'Web',
    },
    paymentType: {
        id: 'payment-type',
        defaultMessage: 'Payment type',
    },
    adjustmentPercent: {
        id: 'adjustment-percent',
        defaultMessage: 'Percent',
    },
    amount: {
        id: 'amount',
        defaultMessage: 'Amount',
    },
    createAdjustmentSuccess: {
        id: 'create-adjustment-success',
        defaultMessage: 'Adjustment created',
    },
    createAdjustmentSuccessDescription: {
        id: 'create-adjustment-success-description',
        defaultMessage: 'A new adjustment has been successfully created.',
    },
    addAdjustmentSubtitle: {
        id: 'add-adjustment-subtitle',
        defaultMessage: 'Add a new adjustment to this pricing plan',
    },
    deleteAdjustment: {
        id: 'delete-adjustment',
        defaultMessage: 'Delete adjustment',
    },
    deleteAdjustmentSuccess: {
        id: 'delete-adjustment-success',
        defaultMessage: 'Adjustment deleted',
    },
    deleteAdjustmentSuccessDescription: {
        id: 'delete-adjustment-success-description',
        defaultMessage: 'The adjustment has been successfully deleted.',
    },
    deleteAdjustmentSubtitle: {
        id: 'delete-adjustment-subtitle',
        defaultMessage: 'Permanently delete adjustment',
    },
    confirmDeleteAdjustment: {
        id: 'confirm-delete-adjustment',
        defaultMessage: 'Are you sure you want to delete this adjustment? This action cannot be undone.',
    },
    updateAdjustmentSuccess: {
        id: 'update-adjustment-success',
        defaultMessage: 'Adjustment updated',
    },
    updateAdjustmentSuccessDescription: {
        id: 'update-adjustment-success-description',
        defaultMessage: 'The adjustment has been successfully updated.',
    },
    editAdjustmentSubtitle: {
        id: 'edit-adjustment-subtitle',
        defaultMessage: 'Edit the details of this adjustment',
    },
    adjustmentPercentError: {
        id: 'custom-error:adjustment_percent',
        defaultMessage: 'Ensure this value is greater than or equal to -100.00.',
    },
    fixedPrice: {
        id: 'fixed-price',
        defaultMessage: 'Fixed price',
    },
    rateWithTax: {
        id: 'rate-with-tax',
        defaultMessage: 'Rate with tax',
    },
    publish: {
        id: 'publish',
        defaultMessage: 'Publish',
    },
    publishPlan: {
        id: 'publish-plan',
        defaultMessage: 'Publish plan {entry}',
    },
    confirmPublishPlan: {
        id: 'confirm-publish-plan',
        defaultMessage: 'Are you sure you want to publish pricing plan {entry}?',
    },
    publishPricingPlanSuccess: {
        id: 'publish-pricing-plan-success',
        defaultMessage: 'Pricing plan published',
    },
    publishPricingPlanSuccessDescription: {
        id: 'publish-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully published.',
    },
    isException: {
        id: 'is-exception',
        defaultMessage: 'Exception',
    },
    isExceptionMoreInfo: {
        id: 'is-exception-more-info',
        defaultMessage:
            'An exception assignment (e.g. for the holidays) may overlap the standard assignment of the same zone, site or gateway and takes precedence over it while both are valid. It belongs to the assignment, not to the pricing plan - the same plan may be the standard tariff of one object and the exception of another.',
    },
    pricingPlanKind: {
        id: 'pricing-plan-kind',
        defaultMessage: 'Kind',
    },
    standardPricingPlan: {
        id: 'standard-pricing-plan',
        defaultMessage: 'Standard',
    },
    exceptionPricingPlan: {
        id: 'exception-pricing-plan',
        defaultMessage: 'Exception',
    },
    relationOverlapError: {
        id: 'custom-error:pricing_plan_relation_overlap',
        defaultMessage:
            'The validity overlaps with another pricing plan of the same kind (standard or exception) assigned to this object!',
    },
    openEndedRelationExistsError: {
        id: 'custom-error:open_ended_pricing_plan_relation_exists',
        defaultMessage: 'There is already a pricing-plan assignment without an end date for this object!',
    },
    versionsOverlapError: {
        id: 'custom-error:pricing_plan_versions_overlap',
        defaultMessage: 'The validity overlaps another version of this pricing plan!',
    },
    changeOverlapsAssignmentsError: {
        id: 'custom-error:pricing_plan_change_overlaps_assignments',
        defaultMessage:
            'The change cannot be saved - where the pricing plan is assigned, it would overlap another pricing plan of the same kind!',
    },
    tickRateOverlapError: {
        id: 'custom-error:pricing_plan_tick_rate_overlap',
        defaultMessage: 'The times of the tick rate are overlapping with another tick rate.',
    },
    tickRateStartAfterEndError: {
        id: 'custom-error:pricing_plan_tick_rate_start_after_end',
        defaultMessage:
            'The band ends on the day it starts on, before it starts. A band through the night is entered with two different days.',
    },
    usedIn: {
        id: 'used-in',
        defaultMessage: 'Used in',
    },
    plansUsedInTable: {
        id: 'plans-used-in-table',
        defaultMessage: 'Plans',
    },
    cap: {
        id: 'cap',
        defaultMessage: 'Cap',
    },
    createCapSuccess: {
        id: 'create-cap-success',
        defaultMessage: 'Cap created',
    },
    createCapSuccessDescription: {
        id: 'create-cap-success-description',
        defaultMessage: 'A new cap has been successfully created.',
    },
    createCapSubtitle: {
        id: 'create-cap-subtitle',
        defaultMessage: 'Add a new cap to this pricing plan',
    },
    deleteCapSuccess: {
        id: 'delete-cap-success',
        defaultMessage: 'Cap deleted',
    },
    deleteCapSuccessDescription: {
        id: 'delete-cap-success-description',
        defaultMessage: 'Cap has been successfully deleted.',
    },
    deleteCapSubtitle: {
        id: 'delete-cap-subtitle',
        defaultMessage: 'Permanently delete cap',
    },
    confirmDeleteCap: {
        id: 'confirm-delete-cap',
        defaultMessage: 'Are you sure you want to delete this cap? This action cannot be undone.',
    },
    updateCapSuccess: {
        id: 'update-cap-success',
        defaultMessage: 'Cap updated',
    },
    updateCapSuccessDescription: {
        id: 'update-cap-success-description',
        defaultMessage: 'The cap has been successfully updated.',
    },
    editCapSubtitle: {
        id: 'edit-cap-subtitle',
        defaultMessage: 'Edit cap details',
    },
    startMinute: {
        id: 'start-minute',
        defaultMessage: 'Start minute',
    },
    endMinute: {
        id: 'end-minute',
        defaultMessage: 'End minute',
    },
    tickDurationMinutes: {
        id: 'tick-duration-minutes',
        defaultMessage: 'Tick duration minutes',
    },
    tier: {
        id: 'tier',
        defaultMessage: 'Tier',
    },
    tickTypeColumn: {
        id: 'tick-type-column',
        defaultMessage: 'Tick type',
    },
    createTierSuccess: {
        id: 'create-tier-success',
        defaultMessage: 'Tier created',
    },
    createTierSuccessDescription: {
        id: 'create-tier-success-description',
        defaultMessage: 'A new tier has been successfully created.',
    },
    addTierSubtitle: {
        id: 'add-tier-subtitle',
        defaultMessage: 'Add a new tier to this pricing plan',
    },
    deleteTierSuccess: {
        id: 'delete-tier-success',
        defaultMessage: 'Tier deleted',
    },
    deleteTierSuccessDescription: {
        id: 'delete-tier-success-description',
        defaultMessage: 'Tier has been successfully deleted.',
    },
    deleteTierSubtitle: {
        id: 'delete-tier-subtitle',
        defaultMessage: 'Permanently delete tier',
    },
    confirmDeleteTier: {
        id: 'confirm-delete-tier',
        defaultMessage: 'Are you sure you want to delete this tier? This action cannot be undone.',
    },
    updateTierSuccess: {
        id: 'update-tier-success',
        defaultMessage: 'Tier updated',
    },
    updateTierSuccessDescription: {
        id: 'update-tier-success-description',
        defaultMessage: 'The tier has been successfully updated.',
    },
    editTierSubtitle: {
        id: 'edit-tier-subtitle',
        defaultMessage: 'Edit tier details',
    },
    noCapping: {
        id: 'no-capping',
        defaultMessage: 'No capping',
    },
    isSystem: {
        id: 'is-system',
        defaultMessage: 'System',
    },
    copyPricingPlanSubtitle: {
        id: 'copy-pricing-plan-subtitle',
        defaultMessage: 'Copy pricing plan {entry}',
    },
    copyPricingPlanSuccess: {
        id: 'copy-pricing-plan-success',
        defaultMessage: 'Pricing plan copied',
    },
    copyPricingPlanSuccessDescription: {
        id: 'copy-pricing-plan-success-description',
        defaultMessage: 'Pricing plan {entry} has been successfully copied.',
    },
    extraFreeTime: {
        id: 'extra-free-time',
        defaultMessage: 'Extra free time',
    },
    extraFreeTimeMinutes: {
        id: 'extra-free-time-minutes',
        defaultMessage: 'Extra free minutes',
    },
    extraFreeTimeActivationRemainingMinutes: {
        id: 'extra-free-time-activation-remaining-minutes',
        defaultMessage: 'Remaining free minutes',
    },
    extraFreeTimeActivationRemainingMinutesMoreInfo: {
        id: 'extra-free-time-activation-remaining-minutes-more-info',
        defaultMessage:
            'The additional minutes are added to the remaining free time if it is less than or equal to the remaining free minutes.',
    },
    versions: {
        id: 'versions',
        defaultMessage: 'Versions',
    },
    version: {
        id: 'version',
        defaultMessage: 'Version',
    },
    viewAllRecords: {
        id: 'view-all-records',
        defaultMessage: '{count, plural, one {View record} other {View all # records}}',
    },
    affectedNow: {
        id: 'affected-now',
        defaultMessage: 'Affected now',
    },
    numberOfActiveStays: {
        id: 'number-of-active-stays',
        defaultMessage: '{count, plural, =0 {# active stays} one {# active stay} other {# active stays}}',
    },
    numberOfActiveMemberships: {
        id: 'number-of-active-memberships',
        defaultMessage:
            '{count, plural, =0 {# active memberships} one {# active membership} other {# active memberships}}',
    },
    plannedChanges: {
        id: 'planned-changes',
        defaultMessage: 'Planned changes - not yet in effect',
    },
    usedInRecordsAsOf: {
        id: 'used-in-records-as-of',
        defaultMessage: 'Affected {count} records as of {date}',
    },
    affectedRecordsCount: {
        id: 'affected-records-count',
        defaultMessage: 'Affects {count, plural, =0 {# records} one {# record} other {# records}}',
    },
    newRulesDescription: {
        id: 'new-rules-description',
        defaultMessage:
            ' - {detailedAffectedRecords}. The new rules are valid from {date}{count, plural, =0 {.} other {. Currently affected: {affectedRecordsMessage} - the recalculation will follow the new rules.}}',
    },
    and: {
        id: 'and',
        defaultMessage: 'and',
    },
    records: {
        id: 'records',
        defaultMessage: 'Records',
    },
    record: {
        id: 'record',
        defaultMessage: 'Record',
    },
    zoneEntity: {
        id: 'zone-entity',
        defaultMessage: '{value, plural, =0 {# zones} one {# zone} other {# zones}}',
    },
    siteEntity: {
        id: 'site-entity',
        defaultMessage: '{value, plural, =0 {# sites} one {# site} other {# sites}}',
    },
    gatewayEntity: {
        id: 'gateway-entity',
        defaultMessage: '{value, plural, =0 {# gateways} one {# gateway} other {# gateways}}',
    },
    membershipEntity: {
        id: 'membership-entity',
        defaultMessage: '{value, plural, =0 {# memberships} one {# membership} other {# memberships}}',
    },
    templateEntity: {
        id: 'template-entity',
        defaultMessage: '{value, plural, =0 {# templates} one {# template} other {# templates}}',
    },
    zoneEntityBadge: {
        id: 'zone-entity-badge',
        defaultMessage: '{value, plural, =0 {Zones} one {Zone} other {Zones}}',
    },
    siteEntityBadge: {
        id: 'site-entity-badge',
        defaultMessage: '{value, plural, =0 {Sites} one {Site} other {Sites}}',
    },
    gatewayEntityBadge: {
        id: 'gateway-entity-badge',
        defaultMessage: '{value, plural, =0 {Gateways} one {Gateway} other {Gateways}}',
    },
    membershipEntityBadge: {
        id: 'membership-entity-badge',
        defaultMessage: '{value, plural, =0 {Memberships} one {Membership} other {Memberships}}',
    },
    templateEntityBadge: {
        id: 'template-entity-badge',
        defaultMessage:
            '{value, plural, =0 {Membership templates} one {Membership template} other {Membership templates}}',
    },
    modifyPricingPlanError: {
        id: 'custom-error:modify_published_pricing_plan',
        defaultMessage:
            'Published pricing plans cannot be deleted or modified. Only the name and description are editable.',
    },
    missingFixedRateError: {
        id: 'custom-error:missing_fixed_rate',
        defaultMessage: 'The fixed rate is required for fixed price calculation type!',
    },
    publishedPricingPlanError: {
        id: 'custom-error:published_pricing_plan_component_read_only',
        defaultMessage: 'Published pricing plan and their related entities cannot be modified or deleted!',
    },
    currencyRate: {
        id: 'currency-rate',
        defaultMessage: 'Rate ({currency})',
    },
    currencyAmount: {
        id: 'currency-amount',
        defaultMessage: 'Amount ({currency})',
    },
});
